import { Box, styled } from '@mui/material'
import { FC, ReactChild } from 'react'

const Container = styled(Box)`
  --side-background-color: rgba(0, 0, 0, 0);
  --center-background-color: rgba(0, 0, 0, 0.8);

  align-items: center;
  background: linear-gradient(
    90deg,
    var(--side-background-color) 0%,
    var(--center-background-color) 50%,
    var(--side-background-color) 100%
  );
  display: flex;
  flex-direction: column;
`

const ApeironGradientBox: FC<Props> = (props: Props) => {
  const { children, className } = props

  return <Container className={className}>{children}</Container>
}

type Props = {
  children: ReactChild | ReactChild[]
  className?: string
}

export default ApeironGradientBox
